import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useStickyHeader from '../hooks/useStickyHeader';
import useMobileNav from '../hooks/useMobileNav';
import './Header.css';

const Header = () => {
  const { headerRef } = useStickyHeader(50);
  const { toggleMenu, toggleRef, menuRef } = useMobileNav();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <header id="header" className="header" ref={headerRef}>
      <div className="header-content">
        <div className="site-title">
          <h1>
            <Link to="/" className="site-title-link">
              <img
                src="/images/alex-bikfalvi-bold.svg"
                alt="alex bikfalvi"
                className="pixelated-title"
                width="650"
                height="90"
              />
            </Link>
          </h1>
        </div>
        <nav className="nav" role="navigation" aria-label="Main navigation">
          <ul className="nav-list" ref={menuRef} aria-expanded="false">
            <li className={`nav-item ${isActive('/') ? 'nav-item--active' : ''}`}>
              <Link to="/" className="nav-link" accessKey="H">
                <span className="accesskey">H</span>ome
              </Link>
            </li>
            <li className={`nav-item ${isActive('/bio') ? 'nav-item--active' : ''}`}>
              <Link to="/bio" className="nav-link" accessKey="B">
                <span className="accesskey">B</span>io
              </Link>
            </li>
            <li className="nav-item">
              <a href="/research.html" className="nav-link" accessKey="R">
                <span className="accesskey">R</span>esearch
              </a>
            </li>
            <li className="nav-item">
              <a href="/projects.html" className="nav-link" accessKey="J">
                Pro<span className="accesskey">j</span>ects
              </a>
            </li>
            <li className="nav-item">
              <a href="/pubs.html" className="nav-link" accessKey="P">
                <span className="accesskey">P</span>ublications
              </a>
            </li>
            <li className="nav-item">
              <a href="/teaching.html" className="nav-link" accessKey="T">
                <span className="accesskey">T</span>eaching
              </a>
            </li>
            <li className="nav-item">
              <a href="/events.html" className="nav-link" accessKey="E">
                <span className="accesskey">E</span>vents
              </a>
            </li>
          </ul>
          <button
            ref={toggleRef}
            className="nav-toggle"
            aria-expanded="false"
            aria-controls="nav-list"
            aria-label="Toggle navigation menu"
            onClick={toggleMenu}
          >
            <span className="nav-toggle-line"></span>
            <span className="nav-toggle-line"></span>
            <span className="nav-toggle-line"></span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;

